import {FormControl, FormGroup, ValidationErrors} from '@angular/forms';
import {each} from 'lodash';

function otherSubscribeValueChanges(
  control: FormControl,
  subscriptions: any,
  keys: string[]
) {
  each(keys, (key) => {
    const _control = control.root.get(key);
    if (!subscriptions[key] && _control) {
      subscriptions[key] = _control.valueChanges.subscribe(() => {
        setTimeout(() => {
          control?.updateValueAndValidity({ emitEvent: false });
        });
      });
    }
  });
}

export function oneRequired(keys: string[]): ValidationErrors | null {
  const subscription = {};
  return (control: FormControl) => {
    otherSubscribeValueChanges(control, subscription, keys);

    let valid = false;
    each(keys, (key) => {
      if (control.root.get(key)?.value) {
        valid = true;
      }
    });

    return valid ? null : { oneRequired: true };
  };
}
export function oneOfGroupRequired(): ValidationErrors | null {
  return (control: FormGroup) => {
    let valid = false;

    Object.keys(control.controls).forEach((key) => {
      if (control.controls[key].value) {
        valid = true;
      }
    });

    return valid ? null : { oneOfGroupRequired: true };
  };
}
